import React, { useEffect, useRef, useState } from "react";
import { jsPDF } from "jspdf";
import Button from "../Button";
import { applyPlugin } from "jspdf-autotable";

applyPlugin(jsPDF);

const PayoutPdf = (props) => {
  const printRef = useRef();
  let pdf = new jsPDF();

  function handleDownloadPdf(output) {
    if (!pdf) {
      pdf = new jsPDF();
    }
    props.createHeader && props.createHeader(pdf);

    pdf.autoTable({
      startY: 60,
      startX: props.startX,
      html: printRef.current.querySelector(`#${props.id}`),
      setText: "Times",
      margin: { top: 4, left: 4, right: 4, bottom: 10 },
      useCss: true,
      styles: {
        font: "Times",
        overflow: "linebreak",
        lineColor: [44, 62, 80],
        lineWidth: 0.5,
      },
      headStyles: {
        fillColor: [241, 196, 15],
        fontSize: 15,
      },
      footStyles: {
        fillColor: [241, 196, 15],
        fontSize: 15,
      },
      bodyStyles: {
        fillColor: [255, 255, 255],
        textColor: 240,
        valign: "middle",
        halign: "center",
      },
      rowPageBreak: props.rowPageBreak,
      didDrawCell: props.didDrawCell,
      willDrawCell: props.willDrawCell,
      didParseCell: props.didParseCell,
      // didDrawPage: props.didDrawPage,
    });

    const pages = pdf.internal.getNumberOfPages();
    const pageWidth = pdf.internal.pageSize.width;
    const pageHeight = pdf.internal.pageSize.height;
    pdf.setFontSize(10);

    for (let j = 1; j < pages + 1; j++) {
      let horizontalPos = 5;
      let verticalPos = pageHeight - 5;
      pdf.setPage(j);
      pdf.text(
        `Page ${j} of ${pages}   ${props.pageData}`,
        horizontalPos,
        verticalPos,
        {
          align: "left",
        }
      );
    }

    return output
      ? pdf
      : pdf.save(props.fileName, { returnPromise: true }).then((i) => {
          pdf = null;
        });
  }

  function getPdfOutput() {
    const pdf = handleDownloadPdf(true);
    const pageCount = addFooters();
    const output = pdf.output();
    return output;
  }

  function addFooters() {
    const pageCount = pdf.internal.getNumberOfPages();
    for (var i = 1; i <= pageCount; i++) {
      pdf.text(String(i), 196, 285);
    }
  }

  const childrenWithProps = React.Children.map(props.children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        handleDownloadPdf,
        getPdfOutput,
        addFooters,
      });
    }
    return child;
  });

  return (
    <>
      {childrenWithProps}
      <div className="hidden" ref={printRef}>
        {props.layout}
      </div>
    </>
  );
};

export default PayoutPdf;
